/**
 * @function changeEmailsToArray Return an array of strings generated by a comma separated string. Return empty array
 * if empty string.
 *
 * @param {string} emails - single string containing list of emails separated by commas.
 */
export const changeEmailsToArray = emails =>
  emails.length === 0 ? [] : emails.trim().replace(/\s/g, '').split(',');
